import React from "react";
import {SettingsRowValue} from "../../common/CustomTable/CustomTable";
import {useTranslation} from "react-i18next";
import Collapsable from "../../common/Collapsable/Collapsable";
import Text from "../../common/Text/Text";
import {boolToString, getEntries, isNotEmptyNorFalsy} from "../../../utilities/helperFunctions";

function GenAiServiceSettings(props) {
    const {t} = useTranslation(['thirdPartyService']);
    const {
        thirdPartyService,
        style,
        isDisabled
    } = props;

    return (
        <>
            <Collapsable label={t('thirdPartyService:label.genAiSettings')}
                style={style} isDisabled={isDisabled}
            >
                <div className="settings-table">
                    <div className="table-row-group">
                        <SettingsRowValue label={t('thirdPartyService:label.url')}
                            value={thirdPartyService.url} isDisabled={isDisabled}/>
                        <SettingsRowValue label={t('thirdPartyService:label.model')}
                                          value={thirdPartyService.model} isDisabled={isDisabled}/>
                    </div>
                </div>
                {thirdPartyService.disableSystemRole &&
                    <Text value={t(`thirdPartyService:label.disableSystemRole`)}
                          isDisabled={isDisabled}/>
                }

            </Collapsable>

            {isNotEmptyNorFalsy(thirdPartyService.customParameters) && <Collapsable label={t('thirdPartyService:label.customParameters')}
                         style={style} isDisabled={isDisabled}
            >
                <div className="settings-table">
                    <div className="table-row-group">
                        {getEntries(thirdPartyService.customParameters).map(([key, value]) =>
                            <SettingsRowValue key={key} label={key} showIfNull
                                              value={value} isDisabled={isDisabled}/>
                        )}
                    </div>
                </div>
            </Collapsable>
            }
        </>
    )
}

export default GenAiServiceSettings;
